// extracted by mini-css-extract-plugin
export default {"root":"styles_root__PbjGI","title":"styles_title__u2J6-","icon":"styles_icon__gdfaU","unlocked":"styles_unlocked__tbhGT"};